import React from 'react';
import DossierCard from './DossierCard';
import { motion, AnimatePresence } from 'framer-motion';
import { Sailboat } from 'lucide-react';
import MiniLoader from '../../../components/MiniLoader';

export default function ForumGrid({ dossiers, loading, progress }) {
  if (loading) {
    return (
      <div className="py-12">
        <MiniLoader progress={progress} />
      </div>
    );
  }

 if (!dossiers || dossiers.length === 0) {
 return (
 <div className="text-center py-16 workspace-card flex flex-col items-center justify-center">
 <motion.div
 animate={{ y: [-5, 5, -5], rotate: [-3, 3, -3] }}
 transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
 className="mb-4 text-tertiary opacity-60"
 >
 <Sailboat className="w-16 h-16" />
 </motion.div>
 <p className="text-primary font-medium text-lg">Aucun dossier trouvé.</p>
 <p className="text-sm text-tertiary mt-1">La mer est calme... essayez de modifier vos critères de recherche.</p>
 </div>
 );
 }

 const gridVariants = {
 hidden: { opacity: 0 },
 show: {
 opacity: 1,
 transition: { staggerChildren: 0.05 }
 }
 };

 const itemVariants = {
 hidden: { opacity: 0, y: 15 },
 show: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 300, damping: 24 } }
 };

  return (
    <AnimatePresence mode="wait">
      <motion.div 
        key={dossiers.map(d => d.id).join('-') || 'empty-grid'}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6"
        variants={gridVariants}
        initial="hidden"
        animate="show"
        exit={{ opacity: 0, transition: { duration: 0.2 } }}
      >
        {dossiers.map(dossier => (
          <motion.div key={dossier.id} variants={itemVariants}>
            <DossierCard dossier={dossier} />
          </motion.div>
        ))}
      </motion.div>
    </AnimatePresence>
  );
}
